import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import useBreakpoint from '../../hooks/useBreakpoint.js';
import Tippy from '@tippyjs/react';
import styles from './styles.css.js';

var HoverCard = function HoverCard(_a) {
  var _b;

  var children = _a.children,
      className = _a.className,
      message = _a.message,
      _c = _a.theme,
      theme = _c === void 0 ? 'light' : _c,
      _d = _a.hideTargetOnMobile,
      hideTargetOnMobile = _d === void 0 ? false : _d,
      rest = __rest(_a, ["children", "className", "message", "theme", "hideTargetOnMobile"]);

  var isMobile = !useBreakpoint('sm');

  if (isMobile) {
    return hideTargetOnMobile ? null : React.createElement(React.Fragment, null, children);
  } else {
    // Using <span> is hack so that the child doesn't need to use React.forwardRef()
    return React.createElement(Tippy, __assign({
      content: message,
      className: classnames(styles.tooltip, className, (_b = {}, _b[styles.light] = theme === 'light', _b[styles.dark] = theme === 'dark', _b)),
      arrow: true
    }, rest), React.createElement("span", null, children));
  }
};

export default HoverCard;
//# sourceMappingURL=index.js.map
